export default {"src":"/_next/static/media/eg.16cffb05.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};